import{observer,ComponentView,Preact,h,state,action,Router,Link,Cls,m,Media} from "@websites/website_compiler/Client";
import {AEComponentView,AEComponentViewProps} from "../stores/ui";
import { MediaQuerySizes } from "./Base";
import * as C from "./BaseCss";
import * as Css from "./SidepanelCss"
import * as Icons from "./Icons";


function RowBtn(props:{active?:boolean,icon:any,text:string,href?:string}){
    var Icon = props.icon;
    // NEED TO ADD COLOR TO STYLE OR CAUSES AN ERROR IN CHROME WHEN SWITCHING SIDEPANEL COLOR MODES
    return <Link href={props.href} class={m(Css.row,props.active && Css.rowActive)}>
        <Icon class={Css.rowIcon}></Icon>
        <div style={{color:C.fontColor}}>{props.text}</div> 
    </Link>
}

export class Props extends AEComponentViewProps{
    transparentMode?:boolean;
}

export class View extends AEComponentView<Props>{
    containerRef = Preact.createRef();
    @state isTransparent = false;
    
    constructor(props:Props){
        super(props);
        if(!this.ui.serverSide){

        }
    }

    toggleSidePanel = () =>{
        this.ui.toggleSidePanel();
    }
    componentDidMount = () =>{
        this.isTransparent = this.props.transparentMode;
        if(this.props.transparentMode){

            window.addEventListener("resize",(evt)=>{
                this.computeColorMode();
            });
            window.addEventListener("scroll",(evt)=>{
                this.computeColorMode();
            });
        }
    }
    computeColorMode = () =>{
        if(!this.props.transparentMode){ 
            this.isTransparent = false;
            return;
        }
        this.isTransparent = (window.innerWidth > MediaQuerySizes.smallDesktopMin) && window.pageYOffset < (window.innerHeight / 2);

        // console.log("scrollPosition",this.isTransparent)
    }
    render(){
        const ui = this.ui;
        return <Preact.Fragment>
            {this.ui.sidePanelVisible && <div class={Css.mobileBg} onClick={this.toggleSidePanel}></div>}
            <div ref={this.containerRef} class={m(Css.container,this.isTransparent ? null : null)} style={{left:this.ui.sidePanelVisible ? "0px" : null}}>
                <button class={Css.closeBtn} onClick={this.toggleSidePanel}>
                    <Icons.X class={C.icon20px}></Icons.X>
                </button>
                <div class={m(C.columnCenter,Css.logoContainer)}>
                    <Icons.Logo_Icon class={Css.logoIcon}></Icons.Logo_Icon>
                    <Icons.Logo_Text class={Css.logoText}></Icons.Logo_Text>
                    <div class={Css.logoLine}></div>
                    <div class={Css.tagLine}>Living Water Features</div>
                </div>
                <nav class={Css.menu}>
                    <RowBtn icon={Icons.Home} href="/" active={ui.url.pathname == "/"} text="Home"></RowBtn>
                    {/* <RowBtn icon={Icons.Services} href={ui.routes.services.path} active={ui.url.pathname == ui.routes.services.path} text="Services"></RowBtn> */}
                    <RowBtn icon={Icons.Gallery} href={ui.routes.gallery.url()} active={ui.url.pathname == ui.routes.gallery.url()} text="Gallery"></RowBtn>
                    <RowBtn icon={Icons.Contact}  href={ui.routes.contact.url()} active={ui.url.pathname == ui.routes.contact.url()} text="Contact"></RowBtn>
                    {/* <RowBtn icon={Icons.Quote}  href={ui.routes.quote.url()} active={ui.url.pathname == ui.routes.quote.url()} text="Get Quote"></RowBtn> */}
                </nav>
                {/* <Icons.Seaweed_2 class={m(Css.bottomIcon)}></Icons.Seaweed_2> */}

            </div>
            </Preact.Fragment>

        
    }
    
}